package com.evoapps.evoshift.data.repository

import com.evoapps.evoshift.data.remote.AppFirestore
import com.evoapps.evoshift.data.remote.CloudFunctionsClient
import com.evoapps.evoshift.domain.privacy.RosterPrivacyRepository
import kotlinx.serialization.json.buildJsonObject
import kotlinx.serialization.json.put

/**
 * SH-255: `workplaces/{id}/roster_privacy/{uid}` exists while the person is hidden in the roster for
 * the others (read directly: the person their own, managers anyone's); changed only through the
 * setRosterHidden callable (functions/rosterPrivacy.js).
 */
class RosterPrivacyRepositoryImpl(
    private val firestore: AppFirestore,
    private val functions: CloudFunctionsClient
) : RosterPrivacyRepository {

    override suspend fun isHidden(workplaceId: String, userId: String): Result<Boolean> = runCatching {
        val entry = firestore.collection("workplaces").document(workplaceId)
            .collection("roster_privacy").document(userId).get()
        // The function removes the entry when the person is shown again.
        entry.exists
    }

    override suspend fun setHidden(workplaceId: String, userId: String, hidden: Boolean): Result<Unit> = runCatching {
        functions.call("setRosterHidden", buildJsonObject {
            put("workplaceId", workplaceId)
            put("userId", userId)
            put("hidden", hidden)
        })
        Unit
    }
}
